import React, { useCallback } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import './ConfirmModal.css';
import { ReactComponent as CloseIcon } from './close-icon.svg';

const ConfirmationModal = ({
    yesButtonText,
    noButtonText,
    renderIcon,
    renderContent,
    onCancel,
    onConfirm,
}) => {
    const handleScroll = useCallback(e => {
        e.stopPropagation();
    }, []);

    return ReactDOM.createPortal(
        <div className="dialog-container" onScroll={handleScroll}>
            <div className="dialog-body">
                <div>
                    <div className="cursor-pointer" onClick={onCancel}>
                        <CloseIcon />
                    </div>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                    {renderIcon()}
                </div>
                <div className="c-confirm-modal__text d-flex justify-content-center align-items-center mt-4">
                    {renderContent()}
                </div>
                <div className="d-flex justify-content-center align-items-center mt-4 c-confirm-modal__action-buttons">
                    <div className="c-confirm-modal__button-container d-flex justify-content-around align-items-center">
                        <div
                            className="c-confirm-modal__button d-flex justify-content-center align-items-center cursor-pointer"
                            onClick={onConfirm}
                        >
                            {yesButtonText}
                        </div>
                        <div
                            className="c-confirm-modal__button d-flex justify-content-center align-items-center cursor-pointer"
                            onClick={onCancel}
                        >
                            {noButtonText}
                        </div>
                    </div>
                </div>
            </div>
            <div className="dialog-screen-shade" />
        </div>,
        document.body
    );
};

ConfirmationModal.propTypes = {
    yesButtonText: PropTypes.string,
    noButtonText: PropTypes.string,
    renderIcon: PropTypes.func.isRequired,
    renderContent: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

ConfirmationModal.defaultProps = {
    yesButtonText: 'Yes',
    noButtonText: 'No',
};

export default ConfirmationModal;
